import { defineMessages } from '@atlassian/jira-intl';

export const fieldValidationMessages = defineMessages({
	errorFieldDescriptionTooLong: {
		id: 'project-settings-product-features-jsm-tmp.common.utils.field-validator.error-field-description-too-long',
		defaultMessage: "Description can't exceed {maxCharacters} characters",
		description:
			'Error message to show when a field description exceeds the maximum allowed number of characters',
	},
	errorKeyDuplicate: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.options-list.error-key-duplicate',
		defaultMessage: 'Already exists. Try something else.',
		description: 'validation error displayed if field option is duplicate',
	},
});
